import React, {Component} from "react";
import {connect} from 'react-redux';
import {Button, Col, Input, message, Row, Spin, Tooltip} from 'antd';
import {Carousel} from 'react-responsive-carousel';
import {getSavedImages} from '../../../redux_actions/admin.state.action';

import "../../../asset/style/manualmode/mpp_app.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import {get_response} from "../../../helper/request";

class MPPApp extends Component {
	constructor(props) {
		super(props);
		this.state = {
			images: [],
			x1: null,
			y1: null,
			x2: null,
			y2: null,
			mpp: null,
			index: 0
		}
	}

	componentDidMount = () => {
		this.props.dispatch(getSavedImages());
	}

	handleClick1 = (event) => {
		const imgrect = event.target.getBoundingClientRect();
		if (this.state.index == 0){
			const x1 = event.clientX - imgrect.left;
			const y1 = event.clientY - imgrect.top;
			console.log(`Clicked on (${x1}, ${y1})`);
			this.setState({x1,y1})
			this.state.index = 1;
			document.getElementById('mark1').style.display = "block";
		}
		else{
			const x2 = event.clientX - imgrect.left;
			const y2 = event.clientY - imgrect.top;
			console.log(`Clicked on (${x2}, ${y2})`);
			this.setState({x2,y2});
			this.state.index = 0;
			document.getElementById('mark2').style.display = "block";
		}
	}

	copy_mpp = () => {
		let mpp = document.getElementById('point-4').value;
		let partsOfUrl = "api~settings~mpp_calculation/";
		let url = `/server/scano_text/` + this.props.currentState.deviceId + `/` + partsOfUrl + `?mpp=` + mpp;
		get_response(url)
			.then(response => {
				console.log("Success request", response);
				if(response.status === 200){
					message.success("mpp updated successfully")
					console.log("mpp updated");
				}
				else if (response.status === 301){
					message.error(response.data)
					console.log("error 301");
				}
				else{
					message.error(response.data)
					console.log("error");
				}
			})
			.catch(err => {
				console.log("Not able to set mpp", err);
			});
	}

	getSlides = () => {
		const x = this.state.x1;
		const y = this.state.y1;
		let slides = [];
		for(let i = 0; i < this.props.adminState.images.length; i++) {
			let url = 'http://0.0.0.0:3333/media/scandrive/diagnostics/default/maincamera/' + this.props.adminState.images[i];
			slides.push(
				<div key={i} id='img_area' onClick={this.handleClick1} className='img'>
					<img src={url} height="744px" id={'img-'+i} className='images'/>
				</div>
			);
		}
		return slides;
	}

	getAbsoluteMotionRow = (haveRowStyle, showSecondInputField, heading1, heading2, inputField1, inputField2) => {
		return (
			<Row style={haveRowStyle ? { marginTop: 5 } : {}}>
				<Col offset={1} span={3}>
					<b>{heading1}</b>
				</Col>
				<Col span={2}>
					{inputField1}
				</Col>
				{showSecondInputField ?
					<Col offset={11} span={3}>
						<b>{heading2}</b>
					</Col>
					: null
				}
				{showSecondInputField ?
					<Col span={2}>
						{inputField2}
					</Col>
					: null
				}
			</Row>
		)
	}

	getMotionInputField = (ind, val) => {
		return <Input size="small" className="motion-app-input-field" value={val} step='10' min='0' id={"point-"+ind} disabled/>
	}

	reset_all = () => {
		this.setState({x1: null, y1: null, x2: null, y2: null, mpp: null});
		document.getElementById('mark1').style.display = "none";
		document.getElementById('mark2').style.display = "none";
		this.state.index = 0;
	}

	calculate_mpp = () => {
		let x1 = document.getElementById('point-0').value;
		let y1 = document.getElementById('point-1').value;
		let x2 = document.getElementById('point-2').value;
		let y2 = document.getElementById('point-3').value;
		let microns = document.getElementById('distance').value;
		var dist = Math.sqrt(Math.pow((x1-x2),2) + Math.pow((y1-y2),2));
		console.log('dist', dist);
		var mpp = microns/dist;
		console.log('mpp', mpp);
		this.setState({mpp});
	}

	render() {
		let x1 = this.state.x1-9;
		let y1 = this.state.y1-17;
		let x2 = this.state.x2-9;
		let y2 = this.state.y2-17;
		return (
			<Row className="app-parent overlayed-component saved-images-app-width">
				<div>
					<Spin spinning={this.props.adminState.images_action}>
						<Row>
							<Col span={17} id='new_area'>
								<Carousel infiniteLoop useKeyboardArrows dynamicHeight className="thumbs-style">
									{this.getSlides()}

								</Carousel>
								{x1 && y1 &&
									<div style={{ position: 'absolute', left: x1, top: y1, display: "none" }} id='mark1'>
										<span style={{color: 'green', padding: 1, borderRadius: 2, fontSize: 25 }}>X</span>
									</div>
								}
								{x2 && y2 &&
									<div style={{ position: 'absolute', left: x2, top: y2, display: "none" }} id='mark2'>
										<span style={{color: 'green', padding: 1, borderRadius: 2, fontSize: 25 }}>X</span>
									</div>
								}
							</Col>
							<Col span={4} style={{paddingLeft: 15}}>
								<div>
									<br/>
									<Tooltip placement="rightTop">
										<br/><br/><br/>
										<Row style={{marginTop: 1, marginBottom: 7}}>
											<Col offset={0} span={17}>
												<b>Point A</b>
											</Col>
										</Row>
										{this.getAbsoluteMotionRow(false, true, 'X: ', 'Y: ',
											this.getMotionInputField(0, this.state.x1),
											this.getMotionInputField(1, this.state.y1),
										)}
										<br/><br/>
										<Row style={{marginTop: 0, marginBottom: 7}}>
											<Col offset={0} span={17}>
												<b>Point B</b>
											</Col>
										</Row>
										{this.getAbsoluteMotionRow(false, true, 'X: ', 'Y: ',
											this.getMotionInputField(2, this.state.x2),
											this.getMotionInputField(3, this.state.y2),
										)}
										<br/><br/>
										<label htmlFor="distance"><b>Distance in Microns</b></label>
										<Input type="number" id="distance" name="distance" size="small" step='10'
											   defaultValue='0' min='0'/>
										<br/><br/><br/>
										<Button type={"primary"} size="medium" onClick={this.calculate_mpp}>
											Calculate Mpp
										</Button>
										<br/><br/>
										<Row style={{marginTop: 0, marginBottom: 7}}>
											<Col offset={0} span={10}>
												<b>Mpp value: </b>
											</Col>
											<Col offset={1} span={3}>
												{this.getMotionInputField(4, this.state.mpp)}
											</Col>
											<Col offset={9} span={1}>
												<Button type="primary" style={{height: '25px'}} size="medium" onClick={this.copy_mpp}>
													Update
												</Button>
											</Col>
										</Row>
										<br/><br/>
										<Button type={"primary"} size="medium" onClick={this.reset_all}>
											Reset
										</Button>
									</Tooltip>
								</div>
							</Col>
						</Row>
					</Spin>
				</div>
			</Row>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		adminState: state.adminUrlReducer,
		liveView: state.liveViewReducer,
	}
}

export default connect(mapStateToProps)(MPPApp);
